import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMedicinePill2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="medicine-pill-2, tablett"><ellipse cx="11.5" cy="9" rx="9.75" ry="4.25" stroke="currentColor" strokeWidth="1.5"/><path d="M1.75 9V15C1.75 17.3472 6.11522 19.25 11.5 19.25C16.8848 19.25 21.25 17.3472 21.25 15V9" stroke="currentColor" strokeWidth="1.5"/><path d="M5.5 5.5L18.5 12" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconMedicinePill2;
